import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b99ea73"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_2 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_3 = { class: "text-xs text-gray-500" }
const _hoisted_4 = { class: "text-xl md:text-xl font-bold" }
const _hoisted_5 = { class: "content h-full max-h-full" }
const _hoisted_6 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg col-span-8" }, "Allgemeine Punkte", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Frage ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-6",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Beschreibung/Eingabewerte ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Seilzug von/nach Mast:", -1))
const _hoisted_11 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Abspannabschnittlänge:", -1))
const _hoisted_13 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Seilzugfläche Erfordernisse:", -1))
const _hoisted_15 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid gap-0 grid-cols-3 p-0 m-0" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("hr", { class: "trenner" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-0.5" }, [
    /*#__PURE__*/_createElementVNode("hr", { class: "trenner" })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("hr", { class: "trenner" })
  ])
], -1))
const _hoisted_18 = { class: "text-xs text-gray-500" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl md:text-xl font-bold" }, "Seilzugfläche", -1))
const _hoisted_20 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg col-span-8" }, "Allgemeine Punkte", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Frage ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-6",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Beschreibung/Eingabewerte ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Soll-Entfernung zum Mastmittelpunkt:", -1))
const _hoisted_25 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Ist-Entfernung zum Mastmittelpunkt:", -1))
const _hoisted_27 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, "Analyse ", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-5",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, "Analyseergebnisse", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-1 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, "Bewertung", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Nutzungsarten der Fläche:", -1))
const _hoisted_32 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Fremdobjekte auf Fläche:", -1))
const _hoisted_34 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_35 = { class: "text-xs text-gray-500 col-span-6" }
const _hoisted_36 = { class: "text-xs text-gray-500 col-span-6" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Betroffene Flurstücke", -1))
const _hoisted_38 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_39 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_40 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_41 = { class: "text-xs text-gray-500" }
const _hoisted_42 = { class: "h-full max-h-full" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg col-span-8" }, "Geländebeschaffenheit (Seilzugfläche)", -1))
const _hoisted_44 = { class: "mt-0 grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Frage ", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-3",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Beschreibung/Eingabewerte ", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Weitere Eingaben ", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span- text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Bewertung ", -1))
const _hoisted_49 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Art:", -1))
const _hoisted_51 = { class: "text-xs text-gray-500 col-span-1" }
const _hoisted_52 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Art:", -1))
const _hoisted_54 = { class: "text-xs text-gray-500" }
const _hoisted_55 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Anzahl Bäume:", -1))
const _hoisted_57 = { class: "text-xs text-gray-500" }
const _hoisted_58 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Anzahl:", -1))
const _hoisted_60 = { class: "text-xs text-gray-500" }
const _hoisted_61 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_62 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_63 = { class: "text-xs text-gray-500" }
const _hoisted_64 = { class: "h-full max-h-full" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg col-span-8" }, "Geländebeschaffenheit (Seilzugfläche) - Fortsetzung", -1))
const _hoisted_66 = { class: "mt-0 grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Frage ", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-3",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Beschreibung/Eingabewerte ", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Weitere Eingaben ", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span- text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Bewertung ", -1))
const _hoisted_71 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_72 = { class: "col-span-3" }
const _hoisted_73 = { class: "text-xs text-gray-500 col-span-4" }
const _hoisted_74 = { class: "col-span-2" }
const _hoisted_75 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Art:", -1))
const _hoisted_77 = { class: "text-xs text-gray-500" }
const _hoisted_78 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_79 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_80 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_81 = { class: "text-xs text-gray-500" }
const _hoisted_82 = { class: "h-full max-h-full" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-lg md:text-lg" }, "Bilder Seilzugfläche", -1))
const _hoisted_84 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-8 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, null, -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_87 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_88 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_89 = { class: "text-xs text-gray-500" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl md:text-xl font-bold" }, "Zuwegung Seilzugfläche", -1))
const _hoisted_91 = { class: "content h-full max-h-full" }
const _hoisted_92 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg col-span-8" }, "Allgemeine Punkte (Zuwegung Seilzugfläche)", -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, "Analyse ", -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-5",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, "Analyseergebnisse", -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-1 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, "Bewertung", -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs md:text-xs col-span-2" }, "Betroffene Flurstücke:", -1))
const _hoisted_98 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Beschaffenheit:", -1))
const _hoisted_100 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500 col-span-2" }, null, -1))
const _hoisted_102 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_103 = { class: "text-xs text-gray-500 col-span-6" }
const _hoisted_104 = { class: "text-xs text-gray-500 col-span-6" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid gap-0 grid-cols-3 col-span-8 p-0 m-0" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("hr", { class: "trenner" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-0.5" }, [
    /*#__PURE__*/_createElementVNode("hr", { class: "trenner" })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("hr", { class: "trenner" })
  ])
], -1))
const _hoisted_106 = { class: "text-xs text-gray-500 col-span-8" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2 text-lg md:text-lg col-span-8" }, "Geländebeschaffenheit (Zuwegung Seilzugfläche)", -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Frage ", -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-3",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Beschreibung/Eingabewerte ", -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Weitere Eingaben ", -1))
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span- text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Bewertung ", -1))
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Zuwegung Wegeart", -1))
const _hoisted_113 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Zuwegung Länge", -1))
const _hoisted_115 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Zuwegung Breite von-bis", -1))
const _hoisted_117 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_118 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Zuwegung Höhe", -1))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, " Start ", -1))
const _hoisted_121 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, " Ende ", -1))
const _hoisted_123 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, null, -1))
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Unterschied", -1))
const _hoisted_126 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_127 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_128 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-lg md:text-lg col-span-8" }, "Bilder Zuwegung Seilzugfläche", -1))
const _hoisted_130 = { class: "col-span-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-8 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, null, -1))
const _hoisted_132 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_133 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_134 = { class: "text-xs text-gray-500" }
const _hoisted_135 = { class: "h-full max-h-full" }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg col-span-8" }, "Geländebeschaffenheit (Zuwegung Seilzugfläche) - Fortsetzung", -1))
const _hoisted_137 = { class: "mt-0 grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Frage ", -1))
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-3",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Beschreibung/Eingabewerte ", -1))
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Weitere Eingaben ", -1))
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span- text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Bewertung ", -1))
const _hoisted_142 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_143 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_144 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, "Anzahl Bäume:", -1))
const _hoisted_146 = { class: "text-xs text-gray-500" }
const _hoisted_147 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_148 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_149 = { class: "text-xs text-gray-500" }
const _hoisted_150 = { class: "h-full max-h-full" }
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-lg md:text-lg col-span-8" }, "Grabenquerungen", -1))
const _hoisted_152 = {
  key: 0,
  class: "col-span-8"
}
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-8 justify-items-stretch items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Frage"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold col-span-3 border-solid rounded-md whiteYellowBorderColor" }, "Beschreibung/Eingabewerte"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Weitere Eingaben"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span- text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, "Bewertung")
], -1))
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-1" }, "Erforderlich?", -1))
const _hoisted_155 = { class: "text-xs col-span-7 text-gray-500 capitalize" }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, "Anzahl: ", -1))
const _hoisted_157 = { class: "text-xs col-span-3 text-gray-500" }
const _hoisted_158 = { class: "text-xs text-gray-500 col-span-2" }
const _hoisted_159 = { class: "justify-self-end row-span-2" }
const _hoisted_160 = {
  key: 1,
  class: "col-span-8"
}
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2 grid grid-cols-8 justify-items-stretch items-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "justify-center items-center col-span-8",
    style: {"background-color":"rgb(235, 239, 240)","border-style":"solid","border-color":"rgb(235, 239, 240) rgb(235, 239, 240)\n                      rgb(235, 239, 240) rgb(235, 239, 240)","border-radius":"5px"}
  }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-center" }, "Keine Grabenquerungen aufgenommen")
  ])
], -1))
const _hoisted_162 = [
  _hoisted_161
]
const _hoisted_163 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_164 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_165 = { class: "text-xs text-gray-500 col-span-8" }
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl md:text-xl font-bold" }, "Fläche zwischen Mast und Seilzugfläche", -1))
const _hoisted_167 = { class: "content h-full max-h-full" }
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg col-span-8" }, "Allgemeine Punkte (Fläche zwischen Mast und Seilzugfläche)", -1))
const _hoisted_169 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, "Analyse ", -1))
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-5",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, "Analyseergebnisse", -1))
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-1 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, "Bewertung", -1))
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2" }, /*#__PURE__*/_toDisplayString("Nutzungsart der Fläche"), -1))
const _hoisted_174 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs md:text-xs col-span-2" }, "Betroffene Flurstücke:", -1))
const _hoisted_176 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_177 = { class: "text-xs text-gray-500 col-span-6" }
const _hoisted_178 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_179 = { class: "text-xs text-gray-500 col-span-6" }
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid gap-0 grid-cols-3 col-span-8 p-0 mt-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("hr", { class: "trenner" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-0.5" }, [
    /*#__PURE__*/_createElementVNode("hr", { class: "trenner" })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("hr", { class: "trenner" })
  ])
], -1))
const _hoisted_181 = { class: "text-xs text-gray-500 col-span-8" }
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg col-span-8" }, "Geländebeschaffenheit (Fläche zwischen Mast und Seilzugfläche)", -1))
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Frage ", -1))
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-3",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Beschreibung/Eingabewerte ", -1))
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Weitere Eingaben ", -1))
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span- text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Bewertung ", -1))
const _hoisted_187 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, " Art: ", -1))
const _hoisted_189 = { class: "text-xs text-gray-500" }
const _hoisted_190 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, " Anzahl Bäume: ", -1))
const _hoisted_192 = { class: "text-xs text-gray-500" }
const _hoisted_193 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_194 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_195 = { class: "text-xs text-gray-500 col-span-8" }
const _hoisted_196 = { class: "h-full max-h-full" }
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg col-span-8" }, "Geländebeschaffenheit (Fläche zwischen Mast und Seilzugfläche) - Fortsetzung", -1))
const _hoisted_198 = { class: "mt-0 grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Frage ", -1))
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm font-bold col-span-3",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Beschreibung/Eingabewerte ", -1))
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-2 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Weitere Eingaben ", -1))
const _hoisted_202 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span- text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Bewertung ", -1))
const _hoisted_203 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_204 = { class: "col-span-3" }
const _hoisted_205 = { class: "text-xs text-gray-500 col-span-4" }
const _hoisted_206 = { class: "col-span-2" }
const _hoisted_207 = { class: "text-xs text-gray-500 col-span-3" }
const _hoisted_208 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs" }, " Art: ", -1))
const _hoisted_209 = { class: "text-xs text-gray-500" }
const _hoisted_210 = { class: "text-xs text-gray-500 col-span-5" }
const _hoisted_211 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_212 = {
  class: "flex flex-col justify-between",
  style: {"height":"1020px"}
}
const _hoisted_213 = { class: "text-xs text-gray-500 col-span-8" }
const _hoisted_214 = { class: "h-full max-h-full" }
const _hoisted_215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-lg md:text-lg" }, "Bilder Fläche zwischen Mast und Seilzugfläche", -1))
const _hoisted_216 = { class: "grid grid-cols-8 justify-items-stretch items-center gap-y-3" }
const _hoisted_217 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-8 text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, null, -1))
const _hoisted_218 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tng_header = _resolveComponent("tng-header")!
  const _component_is_vorhanden_char_and_label = _resolveComponent("is-vorhanden-char-and-label")!
  const _component_bewertung_chip = _resolveComponent("bewertung-chip")!
  const _component_be_footer = _resolveComponent("be-footer")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!
  const _component_oneto_five_image_div_mehrfach = _resolveComponent("oneto-five-image-div-mehrfach")!
  const _component_pdf_a_4_page = _resolveComponent("pdf-a-4-page")!
  const _component_Oekologie = _resolveComponent("Oekologie")!
  const _component_PdfChip = _resolveComponent("PdfChip")!
  const _component_oneto_five_image_div = _resolveComponent("oneto-five-image-div")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSeilzugflaechen(_ctx.ba), (seilzugflaeche, szfKey) => {
    return (_openBlock(), _createElementBlock("span", { key: szfKey }, [
      _createVNode(_component_pdf_a4_page, {
        "no-margin": "",
        "pdf-key": _ctx.lang
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_tng_header, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createElementVNode("div", _hoisted_3, "Seilzugfläche " + _toDisplayString(szfKey + 1) + " > Allgemein > Allgemeine Punkte", 1),
              _createElementVNode("div", _hoisted_4, "Seilzugfläche " + _toDisplayString(szfKey + 1) + " (" + _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.typ')?.getSelectedAuswahlLabelsString()) + ")", 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _hoisted_8,
                  _hoisted_9,
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'allgemein-modal.allgemein-group.seilzugvonmast')?.['eingabeText']), 1),
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.abspannabschnittlaenge')?.['eingabeText'] 
                    ? seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'allgemein-modal.allgemein-group.abspannabschnittlaenge')?.['eingabeText'] + " m" 
                    : "-"), 1),
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'allgemein-modal.allgemein-group.erfordnerisse')?.getSelectedAuswahlLabelsString()), 1),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "allgemein-modal.allgemein-group.flaeche-vorhanden",
                    label: "Fläche zwischen Mast und Seilzugfläche vorhanden",
                    class: "col-span-8"
                  }, null, 8, ["fragenblock", "ba"])
                ]),
                _hoisted_16,
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, "Seilzugfläche " + _toDisplayString(szfKey + 1) + " > Seilzugfläche > Allgemeine Punkte", 1),
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _hoisted_22,
                  _hoisted_23,
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'seilzugflaeche-modal.allgemein.entfernung-mast-soll')?.['eingabeText'] 
                    ? seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'seilzugflaeche-modal.allgemein.entfernung-mast-soll')?.['eingabeText'] + " m" 
                    : "-"), 1),
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'seilzugflaeche-modal.allgemein.entfernung-mast-ist')?.['eingabeText'] 
                    ? seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'seilzugflaeche-modal.allgemein.entfernung-mast-ist')?.['eingabeText'] + " m" 
                    : "-"), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.allgemein.entfernung-mast-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _hoisted_28,
                  _hoisted_29,
                  _hoisted_30,
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seilzugflaeche.findFrageByRelativePath(_ctx.ba,
                    'seilzugflaeche-modal.allgemein.nutzungsart-der-flaeche'
                  )?.getSelectedAuswahlLabels(), (v, key) => {
                      return (_openBlock(), _createElementBlock("ul", {
                        key: key,
                        class: ""
                      }, [
                        (_openBlock(), _createElementBlock("li", {
                          key: key,
                          class: "text-xs text-gray-500"
                        }, _toDisplayString(v.de), 1))
                      ]))
                    }), 128))
                  ]),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.allgemein.nutzungsart-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.allgemein.fremdobjekte-auf-flaeche')?.['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.allgemein.fremdobjekte-auf-flaeche-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "seilzugflaeche-modal.allgemein.weitere-fremdobjekte-auf-flaeche",
                    label: "Weitere Fremdobjekte:",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_35, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.allgemein.weitere-fremdobjekte-auf-flaeche-beschreibung')?.['eingabeText']), 1),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "seilzugflaeche-modal.allgemein.betreiber-vorhanden",
                    label: "Betreiber Fremdobjekte:",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_36, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.allgemein.betreiber')?.getSelectedAuswahlLabelsString()), 1),
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'seilzugflaeche-modal.allgemein.betroffeneflurstuecke')?.['eingabeText']), 1)
                ])
              ]),
              _createVNode(_component_be_footer, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["pdf-key"]),
      _createVNode(_component_pdf_a_4_page, {
        "no-margin": "",
        "pdf-key": _ctx.lang
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_tng_header, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createElementVNode("div", _hoisted_41, "Seilzugfläche " + _toDisplayString(szfKey + 1) + " > Seilzugfläche > Geländebeschaffenheit (Gefälle/Ausholzung/Rodung/Graben)", 1),
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _hoisted_46,
                  _hoisted_47,
                  _hoisted_48,
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "seilzugflaeche-modal.gefaelle-group.gefaelle-vorhanden",
                    label: "Gefälle/Hang/Böschung",
                    class: "text-xs text-gray-500 col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_49, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.gefaelle-group.gefaelle-beschreibung')?.['eingabeText']), 1),
                  _hoisted_50,
                  _createElementVNode("div", _hoisted_51, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seilzugflaeche.findFrageByRelativePath( _ctx.ba,
                  'seilzugflaeche-modal.gefaelle-group.gefaelle-boeschung-art'
                )?.getSelectedAuswahlLabels(), (v, key) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: key,
                        class: "text-gray-500"
                      }, _toDisplayString(v.de), 1))
                    }), 128))
                  ]),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.gefaelle-group.gefaelle-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "seilzugflaeche-modal.gefaelle-group.gefaelle-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "seilzugflaeche-modal.ausholzung-group.ausholzung-erforderlich",
                    label: "Ausholzung erforderlich",
                    class: "text-xs text-gray-500 col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_52, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.ausholzung-group.ausholzung-beschreibung')?.['eingabeText']), 1),
                  _hoisted_53,
                  _createElementVNode("div", _hoisted_54, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.ausholzung-group.ausholzung-art')?.getSelectedAuswahlLabelsString()), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.ausholzung-group.ausholzung-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "seilzugflaeche-modal.ausholzung-group.ausholzung-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "seilzugflaeche-modal.rodung-group.rodung-erforderlich",
                    label: "Rodung erforderlich",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_55, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.rodung-group.rodung-beschreibung')?.['eingabeText']), 1),
                  _hoisted_56,
                  _createElementVNode("div", _hoisted_57, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.rodung-group.rodung-anzahl-baeume')?.['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.rodung-group.rodung-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "seilzugflaeche-modal.rodung-group.rodung-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "seilzugflaeche-modal.graben-group.graben-vorhanden",
                    label: "Graben vorhanden",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_58, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.graben-group.graben-beschreibung')?.['eingabeText']), 1),
                  _hoisted_59,
                  _createElementVNode("div", _hoisted_60, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.graben-group.graben-anzahl')?.['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.graben-group.graben-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "seilzugflaeche-modal.graben-group.graben-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"])
                ])
              ]),
              _createVNode(_component_be_footer, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["pdf-key"]),
      _createVNode(_component_pdf_a_4_page, {
        "no-margin": "",
        "pdf-key": _ctx.lang
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _createVNode(_component_tng_header, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createElementVNode("div", _hoisted_63, "Seilzugfläche " + _toDisplayString(szfKey + 1) + " > Seilzugfläche > Geländebeschaffenheit (Feuchtgebiete/Naturdenkmäler/Kampfmittel/Sonstiges)", 1),
              _createElementVNode("div", _hoisted_64, [
                _hoisted_65,
                _createElementVNode("div", _hoisted_66, [
                  _hoisted_67,
                  _hoisted_68,
                  _hoisted_69,
                  _hoisted_70,
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "seilzugflaeche-modal.feuchtgebiete-group.feuchtgebiete-vorhanden",
                    label: "Feuchtgebiete vorhanden",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_71, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.feuchtgebiete-group.feuchtgebiete-beschreibung')?.['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.feuchtgebiete-group.feuchtgebiete-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "seilzugflaeche-modal.feuchtgebiete-group.feuchtgebiete-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createElementVNode("div", _hoisted_72, [
                    _createVNode(_component_is_vorhanden_char_and_label, {
                      fragenblock: seilzugflaeche,
                      ba: _ctx.ba,
                      fragesPath: "seilzugflaeche-modal.naturdenkmaeler-group.naturdenkmaeler-vorhanden",
                      label: "Naturdenkmäler vorhanden",
                      class: "col-span-2"
                    }, null, 8, ["fragenblock", "ba"]),
                    _createVNode(_component_is_vorhanden_char_and_label, {
                      fragenblock: seilzugflaeche,
                      ba: _ctx.ba,
                      fragesPath: "seilzugflaeche-modal.naturdenkmaeler-group.weitere-naturdenkmaeler-sichtbar",
                      label: "Weitere Naturdenkmäler sichtbar",
                      class: "col-span-2"
                    }, null, 8, ["fragenblock", "ba"])
                  ]),
                  _createElementVNode("div", _hoisted_73, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.naturdenkmaeler-group.naturdenkmaeler-beschreibung')?.['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.naturdenkmaeler-group.naturdenkmaeler-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "seilzugflaeche-modal.naturdenkmaeler-group.naturdenkmaeler-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createElementVNode("div", _hoisted_74, [
                    _createVNode(_component_is_vorhanden_char_and_label, {
                      fragenblock: seilzugflaeche,
                      ba: _ctx.ba,
                      fragesPath: "seilzugflaeche-modal.kampfmittel-group.kampfmittel-vorhanden",
                      label: "Kampfmittel vorhanden",
                      class: "col-span-2"
                    }, null, 8, ["fragenblock", "ba"]),
                    _createVNode(_component_is_vorhanden_char_and_label, {
                      fragenblock: seilzugflaeche,
                      ba: _ctx.ba,
                      fragesPath: "seilzugflaeche-modal.kampfmittel-group.kampfmittel-freimessung",
                      label: "Freimessung erforderlich",
                      class: "col-span-2"
                    }, null, 8, ["fragenblock", "ba"])
                  ]),
                  _createElementVNode("div", _hoisted_75, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.kampfmittel-group.kampfmittel-beschreibung')?.['eingabeText']), 1),
                  _hoisted_76,
                  _createElementVNode("div", _hoisted_77, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.kampfmittel-group.kampfmittel-art')?.['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.kampfmittel-group.kampfmittel-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "seilzugflaeche-modal.kampfmittel-group.kampfmittel-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "seilzugflaeche-modal.sonstiges-group.sonstiges-vorhanden",
                    label: "Sonstiges vorhanden",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_78, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.sonstiges-group.sonstiges-beschreibung')?.['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "seilzugflaeche-modal.sonstiges-group.sonstiges-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "seilzugflaeche-modal.sonstiges-group.sonstiges-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"])
                ])
              ]),
              _createVNode(_component_be_footer, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["pdf-key"]),
      _createVNode(_component_Oekologie, {
        ba: _ctx.ba,
        immobilie: _ctx.immobilie,
        lang: _ctx.lang,
        oekologie: seilzugflaeche.findFragenblockByRelativePath(_ctx.ba, 'seilzugflaeche-modal.oekologie-group')!,
        "bread-crumb": `Seilzugfläche ${szfKey + 1} > Ökologie`,
        tab: "Seilzugfläche"
      }, null, 8, ["ba", "immobilie", "lang", "oekologie", "bread-crumb"]),
      _createVNode(_component_pdf_a_4_page, {
        "no-margin": "",
        "pdf-key": _ctx.lang
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_79, [
            _createElementVNode("div", _hoisted_80, [
              _createVNode(_component_tng_header, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createElementVNode("div", _hoisted_81, "Seilzugfläche " + _toDisplayString(szfKey + 1) + " > Allgemeine Bilder", 1),
              _createElementVNode("div", _hoisted_82, [
                _hoisted_83,
                _createElementVNode("div", _hoisted_84, [
                  _hoisted_85,
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "seilzugflaeche-modal.bilder-group.bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"])
                ]),
                _hoisted_86
              ]),
              _createVNode(_component_be_footer, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["pdf-key"]),
      _createVNode(_component_pdf_a4_page, {
        "no-margin": "",
        "pdf-key": _ctx.lang
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("div", _hoisted_88, [
              _createVNode(_component_tng_header, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createElementVNode("div", _hoisted_89, "Seilzugfläche " + _toDisplayString(szfKey + 1) + " > Zuwegung Seilzugfläche > Allgemeine Punkte", 1),
              _hoisted_90,
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("div", _hoisted_92, [
                  _hoisted_93,
                  _hoisted_94,
                  _hoisted_95,
                  _hoisted_96,
                  _hoisted_97,
                  _createElementVNode("div", _hoisted_98, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'zuwegung-seilzugflaeche-modal.allgemein.betroffeneflurstuecke')?.['eingabeText']), 1),
                  _hoisted_99,
                  _createElementVNode("div", _hoisted_100, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'zuwegung-seilzugflaeche-modal.beschaffenheit-group.beschaffenheit')?.getSelectedAuswahlLabelsString()), 1),
                  _hoisted_101,
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "zuwegung-seilzugflaeche-modal.beschaffenheit-group.beschaffenheit-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "zuwegung-seilzugflaeche-modal.allgemein.weitere-fremdobjekte-auf-flaeche",
                    label: "Fremdobjekte auf Fläche",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_102, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'zuwegung-seilzugflaeche-modal.allgemein.fremdobjekte-auf-flaeche')?.['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "zuwegung-seilzugflaeche-modal.allgemein.fremdobjekte-auf-flaeche-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "zuwegung-seilzugflaeche-modal.allgemein.weitere-fremdobjekte-auf-flaeche",
                    label: "Weitere Fremdobjekte",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_103, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'zuwegung-seilzugflaeche-modal.allgemein.weitere-fremdobjekte-auf-flaeche-beschreibung')?.['eingabeText']), 1),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "zuwegung-seilzugflaeche-modal.allgemein.betreiber-vorhanden",
                    label: "Betreiber Fremdobjekte",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_104, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'zuwegung-seilzugflaeche-modal.allgemein.betreiber')?.getSelectedAuswahlLabelsString()), 1),
                  _hoisted_105,
                  _createElementVNode("div", _hoisted_106, "Seilzugfläche " + _toDisplayString(szfKey + 1) + " > Zuwegung Seilzugfläche > Geländebeschaffenheit (Zuwegung)", 1),
                  _hoisted_107,
                  _hoisted_108,
                  _hoisted_109,
                  _hoisted_110,
                  _hoisted_111,
                  _hoisted_112,
                  _createElementVNode("div", _hoisted_113, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'zuwegung-seilzugflaeche-modal.zuwegung-wegeart.zuwegung-wegeart-beschreibung')?.getSelectedAuswahlLabelsString()), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "zuwegung-seilzugflaeche-modal.zuwegung-wegeart.zuwegung-wegeart-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _hoisted_114,
                  _createElementVNode("div", _hoisted_115, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'zuwegung-seilzugflaeche-modal.zuwegung-laenge.zuwegung-laenge-m')?.['eingabeText'] 
                  ? seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'zuwegung-seilzugflaeche-modal.zuwegung-laenge.zuwegung-laenge-m')?.['eingabeText'] + " m" 
                  : "-"), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "zuwegung-seilzugflaeche-modal.zuwegung-laenge.zuwegung-laenge-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _hoisted_116,
                  _createElementVNode("div", _hoisted_117, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'zuwegung-seilzugflaeche-modal.zuwegung.zuwegung-breitevonbis')?.['eingabeText'] 
                  ? seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'zuwegung-seilzugflaeche-modal.zuwegung.zuwegung-breitevonbis')?.['eingabeText'] + " m" 
                  : "-"), 1),
                  _createElementVNode("div", _hoisted_118, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'zuwegung-seilzugflaeche-modal.zuwegung.zuwegung-breite-beschreibung')?.['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "zuwegung-seilzugflaeche-modal.zuwegung.zuwegung-breite-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _hoisted_119,
                  _hoisted_120,
                  _createElementVNode("div", _hoisted_121, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'zuwegung-seilzugflaeche-modal.zuwegung-hoehe.zuwegung-hoehe-start')?.['eingabeText'] 
                  ? seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'zuwegung-seilzugflaeche-modal.zuwegung-hoehe.zuwegung-hoehe-start')?.['eingabeText'] + " m" 
                  : "-"), 1),
                  _hoisted_122,
                  _createElementVNode("div", _hoisted_123, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'zuwegung-seilzugflaeche-modal.zuwegung-hoehe.zuwegung-hoehe-ende')?.['eingabeText'] 
                  ? seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'zuwegung-seilzugflaeche-modal.zuwegung-hoehe.zuwegung-hoehe-ende')?.['eingabeText'] + " m" 
                  : "-"), 1),
                  _hoisted_124,
                  _hoisted_125,
                  _createElementVNode("div", _hoisted_126, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'zuwegung-seilzugflaeche-modal.zuwegung-hoehe.zuwegung-hoehenunterschied')?.['eingabeText'] 
                  ? seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'zuwegung-seilzugflaeche-modal.zuwegung-hoehe.zuwegung-hoehenunterschied')?.['eingabeText'] + " m" 
                  : "-"), 1),
                  _createElementVNode("div", _hoisted_127, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'zuwegung-seilzugflaeche-modal.zuwegung-hoehe.zuwegung-hoehe-beschreibung')?.['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "zuwegung-seilzugflaeche-modal.zuwegung-hoehe.zuwegung-hoehe-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "zuwegung-seilzugflaeche-modal.sonstiges-group.sonstiges-vorhanden",
                    label: "Sonstiges vorhanden",
                    class: "text-xs text-gray-500 col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_128, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'zuwegung-seilzugflaeche-modal.sonstiges-group.sonstiges')?.['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "zuwegung-seilzugflaeche-modal.sonstiges-group.sonstiges-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _hoisted_129,
                  _createElementVNode("div", _hoisted_130, [
                    _hoisted_131,
                    _createVNode(_component_oneto_five_image_div_mehrfach, {
                      fragenblock: seilzugflaeche,
                      ba: _ctx.ba,
                      immobilie: _ctx.immobilie,
                      fragesPath: "zuwegung-seilzugflaeche-modal.bilder-group.bilder",
                      lang: _ctx.lang,
                      class: "col-span-8 ml-2"
                    }, null, 8, ["fragenblock", "ba", "immobilie", "lang"])
                  ])
                ])
              ]),
              _createVNode(_component_be_footer, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["pdf-key"]),
      _createVNode(_component_pdf_a_4_page, {
        "no-margin": "",
        "pdf-key": _ctx.lang
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_132, [
            _createElementVNode("div", _hoisted_133, [
              _createVNode(_component_tng_header, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createElementVNode("div", _hoisted_134, "Seilzugfläche " + _toDisplayString(szfKey + 1) + " > Zuwegung Seilzugfläche > Geländebeschaffenheit (Gefälle/Ausholzung/Rodung)", 1),
              _createElementVNode("div", _hoisted_135, [
                _hoisted_136,
                _createElementVNode("div", _hoisted_137, [
                  _hoisted_138,
                  _hoisted_139,
                  _hoisted_140,
                  _hoisted_141,
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "zuwegung-seilzugflaeche-modal.gefaelle-group.gefaelle-vorhanden",
                    label: "Gefälle vorhanden",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_142, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'zuwegung-seilzugflaeche-modal.gefaelle-group.gefaelle-beschreibung')?.['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "zuwegung-seilzugflaeche-modal.gefaelle-group.gefaelle-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "zuwegung-seilzugflaeche-modal.gefaelle-group.gefaelle-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "zuwegung-seilzugflaeche-modal.ausholzung-group.ausholzung-erforderlich",
                    label: "Ausholzung erforderlich",
                    class: "text-xs text-gray-500 col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_143, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'zuwegung-seilzugflaeche-modal.ausholzung-group.ausholzung-beschreibung')?.['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "zuwegung-seilzugflaeche-modal.ausholzung-group.ausholzung-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "zuwegung-seilzugflaeche-modal.ausholzung-group.ausholzung-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "zuwegung-seilzugflaeche-modal.rodung-group.rodung-erforderlich",
                    label: "Rodung erforderlich",
                    class: "text-xs text-gray-500 col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_144, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'zuwegung-seilzugflaeche-modal.rodung-group.rodung-beschreibung')?.['eingabeText']), 1),
                  _hoisted_145,
                  _createElementVNode("div", _hoisted_146, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'zuwegung-seilzugflaeche-modal.rodung-group.anzahl-baeume')?.['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "zuwegung-seilzugflaeche-modal.rodung-group.rodung-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "zuwegung-seilzugflaeche-modal.rodung-group.rodung-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"])
                ])
              ]),
              _createVNode(_component_be_footer, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["pdf-key"]),
      _createVNode(_component_pdf_a_4_page, {
        "no-margin": "",
        "pdf-key": _ctx.lang
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_147, [
            _createElementVNode("div", _hoisted_148, [
              _createVNode(_component_tng_header, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createElementVNode("div", _hoisted_149, "Seilzugfläche " + _toDisplayString(szfKey + 1) + " > Zuwegung Seilzugfläche > Geländebeschaffenheit (Grabenquerungen)", 1),
              _createElementVNode("div", _hoisted_150, [
                _hoisted_151,
                (_ctx.getGrabenquerungen(_ctx.ba, seilzugflaeche) != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_152, [
                      _hoisted_153,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getGrabenquerungen(_ctx.ba, seilzugflaeche).slice(1), (grabenquerung, key) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: key,
                          class: "ml-2 grid grid-cols-8 justify-items-stretch items-center",
                          style: {"border-style":"solid","border-color":"var(--white100) var(--white100) var(--white100) rgb(216, 215, 26)","border-radius":"5px"}
                        }, [
                          _hoisted_154,
                          _createElementVNode("div", _hoisted_155, _toDisplayString(grabenquerung['graben-erforderlich']), 1),
                          _hoisted_156,
                          _createElementVNode("div", _hoisted_157, _toDisplayString(grabenquerung['graben-anzahl']), 1),
                          _createElementVNode("div", _hoisted_158, _toDisplayString(grabenquerung['graben-beschreibung']), 1),
                          _createElementVNode("div", _hoisted_159, [
                            ('plus' === grabenquerung['graben-bewertung'])
                              ? (_openBlock(), _createBlock(_component_PdfChip, {
                                  key: 0,
                                  color: "green",
                                  "mangel-amount-mode": "",
                                  value: "1",
                                  "pdf-mode": ""
                                }))
                              : _createCommentVNode("", true),
                            ('o' === grabenquerung['graben-bewertung'])
                              ? (_openBlock(), _createBlock(_component_PdfChip, {
                                  key: 1,
                                  color: "blue",
                                  "mangel-amount-mode": "",
                                  value: "1",
                                  "pdf-mode": ""
                                }))
                              : _createCommentVNode("", true),
                            ('minus' === grabenquerung['graben-bewertung'])
                              ? (_openBlock(), _createBlock(_component_PdfChip, {
                                  key: 2,
                                  color: "yellow",
                                  "mangel-amount-mode": "",
                                  value: "1",
                                  "pdf-mode": ""
                                }))
                              : _createCommentVNode("", true),
                            ('x' === grabenquerung['graben-bewertung'])
                              ? (_openBlock(), _createBlock(_component_PdfChip, {
                                  key: 3,
                                  color: "red",
                                  "mangel-amount-mode": "",
                                  value: "1",
                                  "pdf-mode": ""
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode(_component_oneto_five_image_div, {
                            ba: _ctx.ba,
                            immobilie: _ctx.immobilie,
                            lang: _ctx.lang,
                            imageObjects: grabenquerung['graben-bilder'],
                            class: "ml-2 col-span-8"
                          }, null, 8, ["ba", "immobilie", "lang", "imageObjects"])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_160, _hoisted_162))
              ]),
              _createVNode(_component_be_footer, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["pdf-key"]),
      _createVNode(_component_Oekologie, {
        ba: _ctx.ba,
        immobilie: _ctx.immobilie,
        lang: _ctx.lang,
        oekologie: seilzugflaeche.findFragenblockByRelativePath(_ctx.ba, 'zuwegung-seilzugflaeche-modal.oekologie-group')!,
        "bread-crumb": `Seilzugfläche ${szfKey + 1 } > Zuwegung Seilzugfläche > Ökologie`,
        tab: "Zuwegung Seilzugflaeche"
      }, null, 8, ["ba", "immobilie", "lang", "oekologie", "bread-crumb"]),
      _createVNode(_component_pdf_a4_page, {
        "no-margin": "",
        "pdf-key": _ctx.lang
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_163, [
            _createElementVNode("div", _hoisted_164, [
              _createVNode(_component_tng_header, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createElementVNode("div", _hoisted_165, "Seilzugfläche " + _toDisplayString(szfKey + 1) + " > Fläche zwischen Mast und Seilzugfläche > Allgemeine Punkte", 1),
              _hoisted_166,
              _createElementVNode("div", _hoisted_167, [
                _hoisted_168,
                _createElementVNode("div", _hoisted_169, [
                  _hoisted_170,
                  _hoisted_171,
                  _hoisted_172,
                  _hoisted_173,
                  _createElementVNode("div", _hoisted_174, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'flaeche-zwischen-mast-und-seilzugflaeche-modal.allgemein.nutzungsart-der-flaeche')?.getSelectedAuswahlLabelsString()), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.allgemein.nutzungsart-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _hoisted_175,
                  _createElementVNode("div", _hoisted_176, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'flaeche-zwischen-mast-und-seilzugflaeche-modal.allgemein.betroffeneflurstuecke')?.['eingabeText']), 1),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.allgemein.betreiber-vorhanden",
                    label: "Betreiber Fremdobjekte",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_177, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'flaeche-zwischen-mast-und-seilzugflaeche-modal.allgemein.betreiber')?.getSelectedAuswahlLabelsString()), 1),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "zuwegung-seilzugflaeche-modal.allgemein.weitere-fremdobjekte-auf-flaeche",
                    label: "Fremdobjekte auf Fläche",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_178, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'flaeche-zwischen-mast-und-seilzugflaeche-modal.allgemein.fremdobjekte-auf-flaeche')?.['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.allgemein.fremdobjekte-auf-flaeche-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "seilzugflaeche-modal.allgemein.weitere-fremdobjekte-auf-flaeche",
                    label: "Weitere Fremdobjekte:",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_179, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'seilzugflaeche-modal.allgemein.weitere-fremdobjekte-auf-flaeche-beschreibung')?.['eingabeText']), 1),
                  _hoisted_180,
                  _createElementVNode("div", _hoisted_181, "Seilzugfläche " + _toDisplayString(szfKey + 1) + " > Fläche zwischen Mast und Seilzugfläche > Geländebeschaffenheit (Ausholzung/Rodung)", 1),
                  _hoisted_182,
                  _hoisted_183,
                  _hoisted_184,
                  _hoisted_185,
                  _hoisted_186,
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.ausholzung-group.ausholzung-erforderlich",
                    label: "Ausholzung erforderlich",
                    class: "text-xs text-gray-500 col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_187, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'flaeche-zwischen-mast-und-seilzugflaeche-modal.ausholzung-group.ausholzung-beschreibung')?.['eingabeText']), 1),
                  _hoisted_188,
                  _createElementVNode("div", _hoisted_189, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'flaeche-zwischen-mast-und-seilzugflaeche-modal.ausholzung-group.ausholzung-art')?.getSelectedAuswahlLabelsString()), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.ausholzung-group.ausholzung-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.ausholzung-group.ausholzung-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.rodung-group.rodung-erforderlich",
                    label: "Rodung erforderlich",
                    class: "text-xs text-gray-500 col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_190, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'flaeche-zwischen-mast-und-seilzugflaeche-modal.rodung-group.rodung-beschreibung')?.['eingabeText']), 1),
                  _hoisted_191,
                  _createElementVNode("div", _hoisted_192, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'flaeche-zwischen-mast-und-seilzugflaeche-modal.rodung-group.rodung-anzahl-baeume')?.['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.rodung-group.rodung-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.rodung-group.rodung-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"])
                ])
              ]),
              _createVNode(_component_be_footer, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["pdf-key"]),
      _createVNode(_component_pdf_a_4_page, {
        "no-margin": "",
        "pdf-key": _ctx.lang
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_193, [
            _createElementVNode("div", _hoisted_194, [
              _createVNode(_component_tng_header, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createElementVNode("div", _hoisted_195, "Seilzugfläche " + _toDisplayString(szfKey + 1) + " > Fläche zwischen Mast und Seilzugfläche > Geländebeschaffenheit (Feuchtgebiete/Naturdenkmäler/Kampfmittel/Sonstiges)", 1),
              _createElementVNode("div", _hoisted_196, [
                _hoisted_197,
                _createElementVNode("div", _hoisted_198, [
                  _hoisted_199,
                  _hoisted_200,
                  _hoisted_201,
                  _hoisted_202,
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.feuchtgebiete-group.feuchtgebiete-vorhanden",
                    label: "Feuchtgebiete vorhanden",
                    class: "text-xs text-gray-500 col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_203, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'flaeche-zwischen-mast-und-seilzugflaeche-modal.feuchtgebiete-group.feuchtgebiete-beschreibung')?.['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.feuchtgebiete-group.feuchtgebiete-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.feuchtgebiete-group.feuchtgebiete-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createElementVNode("div", _hoisted_204, [
                    _createVNode(_component_is_vorhanden_char_and_label, {
                      fragenblock: seilzugflaeche,
                      ba: _ctx.ba,
                      fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.naturdenkmaeler-group.naturdenkmaeler-vorhanden",
                      label: "Naturdenkmäler vorhanden",
                      class: "text-xs text-gray-500 col-span-2"
                    }, null, 8, ["fragenblock", "ba"]),
                    _createVNode(_component_is_vorhanden_char_and_label, {
                      fragenblock: seilzugflaeche,
                      ba: _ctx.ba,
                      fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.naturdenkmaeler-group.weitere-naturdenkmaeler-sichtbar",
                      label: "Weitere Naturdenkmäler sichtbar",
                      class: "text-xs text-gray-500 col-span-2"
                    }, null, 8, ["fragenblock", "ba"])
                  ]),
                  _createElementVNode("div", _hoisted_205, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba, 'flaeche-zwischen-mast-und-seilzugflaeche-modal.naturdenkmaeler-group.naturdenkmaeler-beschreibung')?.['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.naturdenkmaeler-group.naturdenkmaeler-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.naturdenkmaeler-group.naturdenkmaeler-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createElementVNode("div", _hoisted_206, [
                    _createVNode(_component_is_vorhanden_char_and_label, {
                      fragenblock: seilzugflaeche,
                      ba: _ctx.ba,
                      fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.kampfmittel-group.kampfmittel-vorhanden",
                      label: "Kampfmittel vorhanden",
                      class: "col-span-2"
                    }, null, 8, ["fragenblock", "ba"]),
                    _createVNode(_component_is_vorhanden_char_and_label, {
                      fragenblock: seilzugflaeche,
                      ba: _ctx.ba,
                      fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.kampfmittel-group.kampfmittel-freimessung",
                      label: "Freimessung erforderlich",
                      class: "col-span-2"
                    }, null, 8, ["fragenblock", "ba"])
                  ]),
                  _createElementVNode("div", _hoisted_207, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'flaeche-zwischen-mast-und-seilzugflaeche-modal.kampfmittel-group.kampfmittel-beschreibung')?.['eingabeText']), 1),
                  _hoisted_208,
                  _createElementVNode("div", _hoisted_209, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'flaeche-zwischen-mast-und-seilzugflaeche-modal.kampfmittel-group.kampfmittel-art')?.['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.kampfmittel-group.kampfmittel-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.kampfmittel-group.kampfmittel-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_is_vorhanden_char_and_label, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.sonstiges-group.sonstiges-vorhanden",
                    label: "Sonstiges vorhanden",
                    class: "col-span-2"
                  }, null, 8, ["fragenblock", "ba"]),
                  _createElementVNode("div", _hoisted_210, _toDisplayString(seilzugflaeche.findFrageByRelativePath(_ctx.ba,'flaeche-zwischen-mast-und-seilzugflaeche-modal.sonstiges-group.sonstiges-beschreibung')?.['eingabeText']), 1),
                  _createVNode(_component_bewertung_chip, {
                    fragenblock: seilzugflaeche,
                    fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.sonstiges-group.sonstiges-bewertung",
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    lang: _ctx.lang,
                    class: "justify-self-end"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"]),
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.sonstiges-group.sonstiges-bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"])
                ])
              ]),
              _createVNode(_component_be_footer, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["pdf-key"]),
      _createVNode(_component_pdf_a_4_page, {
        "no-margin": "",
        "pdf-key": _ctx.lang
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_211, [
            _createElementVNode("div", _hoisted_212, [
              _createVNode(_component_tng_header, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"]),
              _createElementVNode("div", _hoisted_213, "Seilzugfläche " + _toDisplayString(szfKey + 1) + " > Fläche zwischen Mast und Seilzugfläche > Bilder", 1),
              _createElementVNode("div", _hoisted_214, [
                _hoisted_215,
                _createElementVNode("div", _hoisted_216, [
                  _hoisted_217,
                  _createVNode(_component_oneto_five_image_div_mehrfach, {
                    fragenblock: seilzugflaeche,
                    ba: _ctx.ba,
                    immobilie: _ctx.immobilie,
                    fragesPath: "flaeche-zwischen-mast-und-seilzugflaeche-modal.bilder-group.bilder",
                    lang: _ctx.lang,
                    class: "col-span-8 ml-2"
                  }, null, 8, ["fragenblock", "ba", "immobilie", "lang"])
                ]),
                _hoisted_218
              ]),
              _createVNode(_component_be_footer, {
                ba: _ctx.ba,
                immobilie: _ctx.immobilie,
                lang: _ctx.lang
              }, null, 8, ["ba", "immobilie", "lang"])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["pdf-key"]),
      _createVNode(_component_Oekologie, {
        ba: _ctx.ba,
        immobilie: _ctx.immobilie,
        lang: _ctx.lang,
        oekologie: seilzugflaeche.findFragenblockByRelativePath(_ctx.ba, 'flaeche-zwischen-mast-und-seilzugflaeche-modal.oekologie-group')!,
        "bread-crumb": `Seilzugfläche ${ szfKey + 1 } > Fläche zwischen Mast und Seilzugfläche > Ökologie`,
        tab: "Fläche zwischen Mast und Seilzugfläche"
      }, null, 8, ["ba", "immobilie", "lang", "oekologie", "bread-crumb"])
    ]))
  }), 128))
}